/* FleetPro - "Only show parts that fit" toggle (SERVER-SIDE rewrite 2026-07-14;
   supersedes the client-side cell-hiding version, G0 2026-07-08 + dense-reflow
   6ac687c). WHY: collections paginate 24/page SERVER-side - client hiding left
   ~5 visible cards per page across ~19 pages (gaps, broken-feeling pagination;
   diagnosed 2026-07-09). NOW the toggle drives Shopify's native fitment facet
   on the CURRENT collection/search URL: dense grid, honest pagination/counts.

   STATE = THE URL, nothing else. ON <=> location.search carries a
   filter.p.m.custom.fitment_keys value besides Universal (same predicate as
   fp-truck-chip). sessionStorage fp_fit_only is RETIRED (no auto-reapply on
   other pages - no surprise navigation; back/forward just work via Athens
   popstate -> grid swap -> fp:cards-rendered -> re-apply).

   S&D rules intact: ONE filter family only - the gen key + Universal are OR'd
   WITHIN custom.fitment_keys; engine_keys params are REPLACED on toggle-on
   (families must never combine: S&D ANDs across families = zero results).
   Facet gating via fp-ymm-data facets flags - never emit params Shopify would
   strip. Navigation prefers Athens FacetFiltersForm.renderPage (AJAX swap +
   pushState + sidebar checkbox sync - same call fp-loadmore.js makes), with a
   full-navigation fallback. Spec-primary parts (clutches/solenoid valves) and
   engine-only parts without fitment_keys drop out while ON - the counts line
   says so honestly. */
(function () {
  if (window.__fpFitToggle) return; window.__fpFitToggle = true;
  var FK = 'filter.p.m.custom.fitment_keys';
  var EK = 'filter.p.m.custom.engine_keys';
  var FITISH = { universal: 1, fit: 1, fit_engine: 1, engine_only: 1, check_engine: 1, check_spec: 1, engine_prompt: 1 };
  var DATA = null, navLock = false;

  function injectCss() {
    if (document.getElementById('fp-fittog-css')) return;
    var s = document.createElement('style');
    s.id = 'fp-fittog-css';
    s.textContent =
      '.fp-fittog{display:flex;align-items:center;gap:10px;flex-wrap:wrap;padding:9px 0 3px}' +
      '.fp-fittog[hidden]{display:none}' +
      '.fp-fittog__sw{position:relative;width:40px;height:22px;border-radius:11px;background:#C9D2DD;border:none;cursor:pointer;flex:none;transition:background .18s;padding:0}' +
      '.fp-fittog__sw::after{content:"";position:absolute;top:2px;left:2px;width:18px;height:18px;border-radius:50%;background:#fff;transition:left .18s}' +
      '.fp-fittog__sw[aria-checked="true"]{background:#188A4E}' +
      '.fp-fittog__sw[aria-checked="true"]::after{left:20px}' +
      '.fp-fittog__sw:focus-visible{outline:2px solid #1F4EC9;outline-offset:2px}' +
      '.fp-fittog__lbl{font-size:13.5px;font-weight:700;color:#0B1E3F;cursor:pointer}' +
      '.fp-fittog__counts{font-size:12.5px;color:#5A6675}' +
      '.fp-fittog__all{font-size:12.5px;font-weight:600;color:#1F4EC9}' +
      '.fp-fittog__all[hidden]{display:none}' +
      '.fp-fittog__zero{background:#EEF3FF;border:1px solid #D7E2FA;color:#163E9E;border-radius:10px;padding:11px 13px;font-size:13.5px;margin:8px 0 2px}' +
      '.fp-fittog__zero[hidden]{display:none}' +
      '.fp-fittog__zero a{color:#163E9E;font-weight:700}' +
      '@media (prefers-reduced-motion:reduce){.fp-fittog__sw,.fp-fittog__sw::after{transition:none}}';
    document.head.appendChild(s);
  }
  function cards() {
    var g = document.getElementById('ProductGridContainer');
    if (!g) return [];
    /* product-card wrappers carry .fpc too - one query, unique nodes */
    return Array.prototype.slice.call(g.querySelectorAll('product-card, .fpc'));
  }
  function getActive() {
    return (window.FPGarage && window.FPGarage.getActive) ? window.FPGarage.getActive() : null;
  }
  function usable(active) {
    /* a truck the toggle can filter by. Make-only trucks (e.g. a Mack VIN -
       no gen key in the vocab yet) have value:'' -> toggle self-hides; their
       card badges still work via the make-locked AMT crossing. */
    return !!(active && active.type !== 'trailer' && active.value);
  }
  function gateOk(d) {
    /* facet gating - never emit params Shopify strips (fp-ymm.js pattern) */
    return !!(d && d.facets && d.facets.truck && d.universal);
  }
  function ensureData(mount, cb) {
    if (DATA) { cb(DATA); return; }
    var src = mount.getAttribute('data-src');
    if (!src) { cb(null); return; }
    fetch(src).then(function (r) { return r.json(); })
      .then(function (d) { DATA = d; cb(d); })
      .catch(function () { cb(null); });
  }
  function buildTruckUrl(d, active) {
    if (!gateOk(d)) return null;
    return '/collections/all?' + encodeURIComponent(FK) + '=' + encodeURIComponent(active.value) +
      '&' + encodeURIComponent(FK) + '=' + encodeURIComponent(d.universal);
  }
  function urlOn() {
    try {
      return new URLSearchParams(window.location.search).getAll(FK).some(function (v) {
        return !/^universal/i.test(v);
      });
    } catch (e) { return false; }
  }
  function targetParams(on, active) {
    var p = new URLSearchParams(window.location.search);
    p.delete(FK);     /* the toggle owns this family (clears manual sidebar picks) */
    p.delete('page'); /* a filter change resets pagination - mirrors facets.js */
    if (on) {
      p.delete(EK);   /* NEVER two metafield families in one URL - S&D ANDs across
                         families (verified 0-results hazard, fp-ymm.js) */
      p.append(FK, active.value);
      p.append(FK, DATA.universal);
    }
    return p;
  }
  function sortedQs(p) {
    var pairs = [];
    p.forEach(function (v, k) { pairs.push(k + '=' + v); });
    return pairs.sort().join('&');
  }
  function navigate(p) {
    if (navLock) return;
    navLock = true;
    /* safety: if the AJAX render stalls, let the user try again */
    setTimeout(function () { navLock = false; }, 4000);
    var qs = p.toString();
    if (typeof FacetFiltersForm !== 'undefined' && FacetFiltersForm.renderPage) {
      /* AJAX swap + pushState + sidebar sync + count update (fp-loadmore.js pattern);
         completion re-enters via fp:cards-rendered -> apply() */
      try { FacetFiltersForm.renderPage(qs, null, true); return; } catch (e) { /* hard nav below */ }
    }
    window.location.href = window.location.pathname + (qs ? '?' + qs : '');
  }
  function apply() {
    var mount = document.querySelector('[data-fp-fit-toggle]');
    if (!mount) return;
    injectCss();
    navLock = false; /* a render cycle completed - unlock the switch */
    var zero = document.querySelector('[data-fp-fit-zero]');
    var active = getActive();
    var on = urlOn();
    if (!usable(active)) {
      /* nothing to filter by. If the URL is already filtered (deep link, garage
         cleared), the truck chip's "Filtered to ... Clear" is the escape hatch. */
      mount.hidden = true;
      if (zero) zero.hidden = true;
      return;
    }
    ensureData(mount, function (d) {
      var ok = gateOk(d);
      /* stranding escape: URL already ON -> always render the switch so it can be
         turned OFF, even when the facet gate fails (stale facet_status etc.) */
      if (!ok && !on) { mount.hidden = true; if (zero) zero.hidden = true; return; }
      mount.hidden = false;
      var sw = mount.querySelector('[data-fp-fit-sw]');
      var counts = mount.querySelector('[data-fp-fit-counts]');
      var allLink = mount.querySelector('[data-fp-fit-all]');
      if (sw) sw.setAttribute('aria-checked', String(on));
      var list = cards();
      if (counts) {
        if (on) {
          counts.textContent = 'Truck-matched and universal parts only — engine-fit and spec parts (clutches) are hidden.';
        } else if (list.length) {
          var fit = 0;
          list.forEach(function (c) {
            var n = c.querySelector('[data-fp-cardfit]');
            if (n && FITISH[n.dataset.fpState || '']) fit++;
          });
          counts.textContent = fit + ' of ' + list.length + ' on this page fit your ' + active.label;
        } else {
          counts.textContent = '';
        }
      }
      if (zero) {
        if (on && !list.length) {
          /* server returned zero products for the filter - Shopify's own empty
             state renders in the grid; this note adds the toggle-off path */
          zero.textContent = 'No ' + active.label + '-fit parts here — turn the toggle off to see everything' +
            (window.location.pathname === '/collections/all' ? '.' : ', or ');
          var url = buildTruckUrl(d, active);
          if (url && window.location.pathname !== '/collections/all') {
            var a = document.createElement('a');
            a.href = url;
            a.textContent = 'see all ' + active.label + ' parts →';
            zero.appendChild(a);
          }
          zero.hidden = false;
        } else { zero.hidden = true; }
      }
      if (allLink) {
        var u2 = buildTruckUrl(d, active);
        if (u2 && on && window.location.pathname !== '/collections/all') {
          allLink.href = u2;
          allLink.textContent = 'See all ' + active.label + ' parts →';
          allLink.hidden = false;
        } else {
          allLink.hidden = true; /* on /collections/all it would duplicate this page */
        }
      }
    });
  }
  function reconcile() {
    /* active truck changed while the URL filter is ON: re-point the filter at
       the new truck (or drop it when the new truck has no gen key / cleared). */
    if (!urlOn()) { apply(); return; }
    var mount = document.querySelector('[data-fp-fit-toggle]');
    if (!mount) return;
    var active = getActive();
    if (!usable(active)) { navigate(targetParams(false, null)); return; }
    ensureData(mount, function (d) {
      if (!gateOk(d)) { apply(); return; }
      var next = targetParams(true, active);
      if (sortedQs(next) !== sortedQs(new URLSearchParams(window.location.search))) {
        navigate(next);
      } else {
        apply();
      }
    });
  }
  function wire() {
    var mount = document.querySelector('[data-fp-fit-toggle]');
    if (!mount || mount.dataset.fpWired) return;
    mount.dataset.fpWired = '1';
    function flip() {
      var active = getActive();
      if (!usable(active)) return;
      ensureData(mount, function (d) {
        var on = urlOn();
        if (!on && !gateOk(d)) return; /* can't turn ON without a registered facet */
        var sw = mount.querySelector('[data-fp-fit-sw]');
        if (sw) sw.setAttribute('aria-checked', String(!on)); /* optimistic; settles on next apply() */
        navigate(targetParams(!on, active));
      });
    }
    var sw = mount.querySelector('[data-fp-fit-sw]');
    var lbl = mount.querySelector('[data-fp-fit-lbl]');
    if (sw) sw.addEventListener('click', flip);
    if (lbl) lbl.addEventListener('click', flip);
  }
  function boot() { wire(); apply(); }
  document.addEventListener('fp:cards-rendered', boot);
  document.addEventListener('fp:garage-change', reconcile);
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
